function fileManagementController($uibModal, PackageService, CommonService, fileService, DescriptorService, toasterService, userService, $http, Blob, FileSaver,) {
  const ctrl = this;
  const installTypeMapper = CommonService.installTypeMapper;
  ctrl.getPackageHeader = DescriptorService.getPackageHeader;

  ctrl.$onInit = () => {
    ctrl.editMode = [];
    ctrl.hwCompatibilities = [];
    ctrl.newDescriptorStatus = null;
    ctrl.sortType = 'headerParsed.package_filename'; 
    ctrl.sortReverse = false; 
    ctrl.statusListSoftware = [
      { id: 0, type: 'Sanctioned', disabled: false },
      { id: 1, type: 'Engineering', disabled: false },
      { id: 2, type: 'Valid', disabled: false },
      { id: 3, type: 'Deprecated', disabled: false },
    ];
    ctrl.hasEditDescriptors = userService.hasEditDescriptors();
    ctrl.hasAutoUpload = __env.profile === 'LU'
  };

  ctrl.$onChanges = changes => {
    if (changes.packages) {
      ctrl.processPackages();
    }
  };

  ctrl.setSortType = column => {
    ctrl.sortType = column;
  };

  ctrl.setSortReverse = () => {
    ctrl.sortReverse = !ctrl.sortReverse;
  };

  ctrl.toggleEditMode = pkg => {
    ctrl.isSanctionedNoteDisplayed = false;
    if (ctrl.editMode[pkg.id]) {
      ctrl.editMode[pkg.id] = false;
      // save descriptor
      const packageHeader = ctrl.getPackageHeader(pkg);
      ctrl.descriptorObject = {
        id: pkg.id,
        revision: 'sw',
        type: packageHeader.module_family_name,
        sw_revision: packageHeader.version,
        sw_revision_status: ctrl.newDescriptorStatus,
        compatible_hw: ctrl.hwCompatibilities,
      };
      ctrl.saveDescriptor(ctrl.descriptorObject, pkg);
    } else {
      ctrl.editMode[pkg.id] = true;
      ctrl.filteredHWDescriptors = ctrl.getHWDescriptors(pkg);
    }
  };
  ctrl.cancelEditMode = pkg => {
    ctrl.editMode[pkg.id] = false;
    ctrl.descriptorObject = null;
    ctrl.newDescriptorStatus = null;
  };

  // This gets called when adding a descriptor for a new file
  ctrl.getHWDescriptors = pkg => {
    const packageHeader = ctrl.getPackageHeader(pkg);
    const filteredDescriptor = ctrl.allDescriptors.find(obj => obj.type === packageHeader.module_family_name);
    if (filteredDescriptor !== undefined) {
      // Check if module has sanctioned descriptor for SW and/or HW
      if (filteredDescriptor.sw_revision.length > 0) {
        _.each(filteredDescriptor.sw_revision, version => {
          let option;
          if (version.status === 'Sanctioned' && version.type !== "AVI_DB") {
            option = ctrl.statusListSoftware.find(item => item.type === 'Sanctioned');
          } else if (version.status === 'Valid' && version.type !== "AVI_DB") {
            option = ctrl.statusListSoftware.find(item => item.type === 'Valid');
          } else if (version.status === 'Engineering' && version.type !== "AVI_DB") {
            option = ctrl.statusListSoftware.find(item => item.type === 'Engineering');
          }
          if (option) {
            option.disabled = true;
          }
        });
      }
      return filteredDescriptor.hw_revision;
    }
  };

  ctrl.hwCompatibilityChecked = event => {
    if (ctrl.hwCompatibilities.indexOf(event) !== -1) {
      ctrl.hwCompatibilities.splice(ctrl.hwCompatibilities.indexOf(event), 1);
    } else {
      ctrl.hwCompatibilities.push(event);
    }
  };

  ctrl.openModal = function(item) {
    let modalInstance = $uibModal.open({
      component: 'fileModal',
      windowClass: 'large-size-modal',
      resolve: {
        item: function() {
          return item;
        },
        descriptor: function() {
          return ctrl.getDescriptorStatus(item);
        }
      },
    });

    modalInstance.result.then(
      returnObject => {
        // returnObject is integer when user deletes package, otherwise updateObject
        if (Number.isInteger(returnObject)) {
          PackageService.deletePackage(returnObject).then(() => {
            toasterService.success('toaster.file-removed-success');
            ctrl.refreshPackagesList();
          });
        } else {
          PackageService.uploadPackageToTrains(returnObject).then(
            () => {
              toasterService.success('toaster.package-upload-event', 'toaster.package-upload-start-success');
              ctrl.refreshPackagesList();
            },
            e => {
              toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
              console.error(`Package upload failed: ${e}`);
            }
          );
        }
      },
      // Modal was closed, nothing returned
      () => {}
    );
  };

  ctrl.downloadPackageFile = pkg => {
    let fileName = pkg.fileName;
    pkg.isDownloading = true;
    fileService.downloadPackageFile(fileName).then(response => {
      pkg.isDownloading = false;
      if (response.statusCode !== 200) {
        toasterService.error('toaster.file-download-failure', fileName +  ' Status code:  ' +  response.status);
      } else {
        toasterService.success('toaster.file-download-success', ' ' + fileName);
        FileSaver.saveAs(response.response, fileName);
      }
    });
  };

  ctrl.processPackages = () => {
    ctrl.packages.map(p => {
      p.descriptorStatus = ctrl.getDescriptorStatus(p); 
      p.headerParsed = ctrl.getPackageHeader(p);
      p.installTypeTranslated = installTypeMapper(p.headerParsed.install_type);
    });
  };

  ctrl.getDescriptorStatus = pkg => {
    if (ctrl.allDescriptors) {
      const packageHeader = ctrl.getPackageHeader(pkg);
      const moduleDescriptor = ctrl.allDescriptors.find(obj => obj.type === packageHeader.module_family_name);
      if (moduleDescriptor) {
        for (let version of moduleDescriptor.sw_revision) {
          if (version.version_number === packageHeader.version) {
            return version.status;
          }
        }
      }
      return 'Unknown';
    }
  };

  ctrl.getDescriptorId = pkg => {
    if (ctrl.allDescriptors) {
      const packageHeader = ctrl.getPackageHeader(pkg);
      const moduleDescriptor = ctrl.allDescriptors.find(obj => obj.type === packageHeader.module_family_name);
      if (moduleDescriptor) {
        for (let version of moduleDescriptor.sw_revision) {
          if (version.version_number === packageHeader.version) {
            return version.id;
          }
        }
      }
      return 0;
    }
  };

  ctrl.refreshPackagesList = () => {
    PackageService.getAllPackages().then(
      data => {
        ctrl.packages = data;
        ctrl.processPackages();
      },
      e => {
        console.error(`Data fetch error: ${e}`);
      }
    );
  };

  ctrl.saveDescriptor = (newDescriptor, pkg) => {
    // Add new descriptor
    if (pkg.descriptorStatus === 'Unknown') {
      PackageService.addDescriptor(newDescriptor).then(
        function(response) {
          if (response.errorType) {
            toasterService.error('toaster.descriptors-creation-event', ctrl.createDescriptorErrorMessage(response.errorType));
            return;
          }
          toasterService.success('toaster.descriptors-creation-event', 'toaster.descriptors-new-descriptor-successful');
          PackageService.getAllDescriptors().then(res => {
            ctrl.allDescriptors = res;
            ctrl.processPackages();
          });
        },
      );
    } 
    // Edit existing descriptor
    else {
      let descriptorId = this.getDescriptorId(pkg);
      if (descriptorId === 0) {
        console.error("Failed to resolve the descriptor id.")
        return;
      }
      
      PackageService.editDescriptor(newDescriptor.sw_revision_status, descriptorId).then(
        function(response) {
          if (response.errorType) {
            toasterService.error('toaster.descriptors-edit-event', ctrl.createDescriptorErrorMessage(response.errorType));
            return;
          }
          toasterService.success('toaster.descriptors-edit-event', 'toaster.descriptors-edit-descriptor-successful');
          PackageService.getAllDescriptors().then(res => {
            ctrl.allDescriptors = res;
            ctrl.processPackages();
          });
        },
      );
    }
  };

  ctrl.createDescriptorErrorMessage = errorText => {
    let errorMessage = errorText;
    errorMessage = errorMessage.replaceAll('_', ' ').toLowerCase();
    errorMessage = errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);
    errorMessage = errorMessage.concat('!');
    return errorMessage;
  }

  ctrl.descriptorChanged = () => {
    if (ctrl.newDescriptorStatus === "Sanctioned") {
      ctrl.isSanctionedNoteDisplayed = true;
    } else {
      ctrl.isSanctionedNoteDisplayed = false;
    }
  }
}

angular.module('package-management.module').controller('fileManagementController', fileManagementController);
